module.exports = __webpack_public_path__ + "static/media/app-mobile.4e6935fa.png";